import React from "react";
import endpoints from "configs/endpoints";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import Requester from "common/network/http/Request";
import CheckBigIcon from "themes/cashrent/assets/svg/checkbig.svg";
import noncheck from "themes/cashrent/assets/svg/noncheckb.svg";
import { Link } from "react-router-dom";
import "./stylesheet.scss";

/**
 * Created by vntopmas@gmail.com
 * Email: vntopmas@gmail.com
 **/
class EmailConfirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  componentDidMount = async () => {
    this.verify();
  }

  verify = async () => {
    const response = await Requester.post(endpoints.user.verify, { token: this.props.routeParams.token }, undefined, false, false, true);
    this.setState({ isLoading: false });
    if (response.status === 200) {
      this.setState({ verified: true });
    } else {
      this.setState({ verified: false });
    }
  }

  goToHome = () => {
    window.location.url = "/app";
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="ui-email-confirmation">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        </div>
      );
    } else if (this.state.verified) {
      return (
        <div className="ui-email-confirmation">
          <div className="ui-img-panel"><img src={CheckBigIcon} /></div>
          <div className="ui-thankyou">Congrats!</div>
          <div className="ui-guild">Your account is created.</div>
          <div className="ui-link-panel">
            <Link to={"/#"} onClick={this.goToHome} className="back-to-login-btn">Back to Home</Link>
          </div>
        </div>
      );
    }
    return (
      <div className="ui-email-confirmation">
        <div className="ui-img-panel"><img style={{ width: 72, height: 72 }} src={noncheck} /></div>
        <div className="ui-thankyou" style={{ color: "#D0021B" }}>Failed!</div>
        <div className="ui-guild">Account verification failed!</div>
        <div className="ui-link-panel">
          <Link to={"/#"} onClick={this.goToHome} className="back-to-login-btn">Back to Home</Link>
        </div>
      </div>
    );
  }
}

export default EmailConfirmation;
